import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chrono-time" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import TimeValue, { timeValueToMilliseconds } from '../../../shared/time-control/TimeValue.js';
import { PropType, onUnmounted, ref, toRefs, watch } from 'vue';
import { PlayerTimeData } from '../../../shared/time-control/TimeControl.js';
import { ByoYomiPlayerTimeData } from '../../../shared/time-control/time-controls/ByoYomiTimeControl.js';
import TimeControlType from '../../../shared/time-control/TimeControlType.js';
import { ByoYomiChrono } from '../../../shared/time-control/ByoYomiChrono.js';
import { msToDuration, msToTime } from '../../../shared/app/timeControlUtils.js';
import useServerDateStore from '../../stores/serverDateStore.js';

type ChronoData = {
    time: string;
    ms?: string;
    isPaused?: boolean;
    warning?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppChrono',
  props: {
    timeControlOptions: {
        type: Object as PropType<TimeControlType>,
        required: true,
    },
    playerTimeData: {
        type: Object as PropType<PlayerTimeData>,
        required: true,
    },
},
  setup(__props) {

/* eslint-env browser */
const props = __props;

const { timeControlOptions, playerTimeData } = toRefs(props);

const toChrono = (timeValue: TimeValue): ChronoData => {
    let ms = timeValueToMilliseconds(timeValue, useServerDateStore().newDate());
    const { floor } = Math;
    let sign = '';

    if (ms < 0) {
        ms = -ms;
        sign = '-';
    }

    const chrono: ChronoData = {
        time: `${sign}${msToTime(ms)}`,
        isPaused: 'number' === typeof timeValue,
    };

    if (ms < 10000) {
        chrono.ms = `.${floor((ms % 1000) / 100)}`;
        chrono.warning = ms % 1000 < 500;
    }

    return chrono;
};

const chronoDisplay = ref<ChronoData>({ time: '…' });

let byoYomiChrono: null | ByoYomiChrono = null;

if ('byoyomi' === timeControlOptions.value.type) {
    const { initialTime, periodTime, periodsCount } = timeControlOptions.value.options;
    const { remainingMainTime, remainingPeriods } = (playerTimeData.value as ByoYomiPlayerTimeData);

    byoYomiChrono = new ByoYomiChrono(initialTime, periodTime, periodsCount);

    byoYomiChrono.setMainValue(remainingMainTime);
    byoYomiChrono.setRemainingPeriods(remainingPeriods);

    watch(playerTimeData, (newValue: ByoYomiPlayerTimeData) => {
        if (null === byoYomiChrono) {
            return;
        }

        byoYomiChrono.setMainValue(newValue.remainingMainTime);
        byoYomiChrono.setRemainingPeriods(newValue.remainingPeriods);
    });
}

const chronoThread = setInterval(() => {
    chronoDisplay.value = toChrono(null !== byoYomiChrono
        ? byoYomiChrono.getMainValue()
        : playerTimeData.value.totalRemainingTime,
    );
}, 50);

onUnmounted(() => clearInterval(chronoThread));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass({ 'text-secondary': chronoDisplay.value.isPaused, 'text-warning': chronoDisplay.value.warning })
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(chronoDisplay.value.time), 1),
    (chronoDisplay.value.ms)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(chronoDisplay.value.ms), 1))
      : _createCommentVNode("", true),
    (_unref(timeControlOptions).type === 'byoyomi' && null !== _unref(byoYomiChrono))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _cache[0] || (_cache[0] = _createTextVNode(" + ")),
          _createElementVNode("strong", null, _toDisplayString(_unref(byoYomiChrono).getRemainingPeriods()), 1),
          _createTextVNode(" × " + _toDisplayString(_unref(msToDuration)(_unref(timeControlOptions).options.periodTime)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})